import React from "react";

const getFirstValue = (row, keys, fallback = "") => {
    for (const key of keys) {
        const value = row?.[key];
        if (value !== undefined && value !== null && value !== "") {
            return value;
        }
    }
    return fallback;
};

const sanitizeText = (value, fallback = "-") => {
    if (value === undefined || value === null) return fallback;
    const safe = String(value).replace(/[\u0000-\u001F\u007F]/g, "").trim();
    return safe || fallback;
};

const sanitizeAmount = (value) => {
    const amount = Number(value);
    return Number.isFinite(amount) ? amount.toFixed(2) : "0.00";
};

const sanitizePercent = (value) => {
    const percent = Number(value);
    return Number.isFinite(percent) ? percent.toFixed(2) : "0.00";
};

const formatDate = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return sanitizeText(value);
    return date.toLocaleDateString("en-GB");
};

const resolveRoomType = (item, roomTypeByRoomBookingId, originalRoomType) => {
    const direct = getFirstValue(
        item,
        ["RoomTypeName", "vchRoomTypeName", "RoomType", "vchRoomType"],
        ""
    );
    if (direct) return direct;

    const roomBookingId = getFirstValue(
        item,
        ["intRoomBookingID", "RoomBookingID", "roomBookingID", "RoomBookingId", "RoomID", "roomId"],
        ""
    );
    if (roomBookingId !== "" && roomTypeByRoomBookingId) {
        const mapped = roomTypeByRoomBookingId[String(roomBookingId)];
        if (mapped) return mapped;
    }

    return originalRoomType;
};

const PartialDayCancellationTable = ({
    data = [],
    loading = false,
    error = "",
    originalRoomType = "-",
    roomTypeByRoomBookingId = {},
}) => {
    return (
        <div className="mt-4">
            <h5>Partial Day Cancellation Summary</h5>
            <div className="table-responsive">
                <table
                    className="table table-bordered table-hover shadow-sm rounded text-center align-middle partial-day-cancellation-table"
                    style={{ fontSize: "0.85rem" }}
                >
                    <thead className="bg-light text-dark fw-semibold">
                        <tr>
                            <th>Sl#</th>
                            <th>Modified On</th>
                            <th>Room Type</th>
                            <th>Old Check-In</th>
                            <th>Old Check-Out</th>
                            <th>New Check-In</th>
                            <th>New Check-Out</th>
                            <th>Deduction (%)</th>
                            <th>Deduction (Rs.)</th>
                            <th>New Total Amount (Rs.)</th>
                            <th>Refund (Rs.)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="13">Loading partial cancellation records...</td>
                            </tr>
                        ) : error ? (
                            <tr>
                                <td colSpan="13" className="text-danger">{error}</td>
                            </tr>
                        ) : data.length > 0 ? (
                            data.map((item, index) => (
                                <tr key={item?.intBookingModificationID || item?.id || index}>
                                    <td>{index + 1}</td>
                                    <td>{formatDate(getFirstValue(item, ["dtmCreatedOn", "ModificationDate", "ModifiedOn"], null))}</td>
                                    <td>{sanitizeText(resolveRoomType(item, roomTypeByRoomBookingId, originalRoomType), originalRoomType)}</td>
                                    <td>{formatDate(getFirstValue(item, ["OldCheckIn", "OldCheckInDate"], null))}</td>
                                    <td>{formatDate(getFirstValue(item, ["OldCheckOut", "OldCheckOutDate"], null))}</td>
                                    <td>{formatDate(getFirstValue(item, ["NewCheckIn", "NewCheckInDate"], null))}</td>
                                    <td>{formatDate(getFirstValue(item, ["NewCheckOut", "NewCheckOutDate"], null))}</td>

                                    <td>{sanitizePercent(getFirstValue(item, ["numDeductionPercent", "DeductionPercent"], 0))}</td>
                                    <td>{sanitizeAmount(getFirstValue(item, ["numDeductionAmount", "DeductionAmount"], 0))}</td>
                                    <td>{sanitizeAmount(getFirstValue(item, ["numRefundBaseAmount", "NewBaseAmountTotalAmount"], 0))}</td>
                                    <td>{sanitizeAmount(getFirstValue(item, ["numRefundAmount", "RefundAmount"], 0))}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="13">No partial day cancellation records found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PartialDayCancellationTable;
